import React from 'react'
import { useSelector } from 'react-redux'
import { useHistory, useParams, useLocation } from 'react-router-dom'
import { DashboardLayout, Select, Tabs, ThemeIcon } from '../../components'
import { capitalize, isDesktop } from '../../utils'
import Coins from './Coins'
import Collectibles from './Collectibles'

import './Wallet.scss'

const TABS = ['Coins', 'Collectibles']
const COINS_TABS = ['History', 'Send', 'Receive']
const HISTORY_OPTIONS = [
   { value: 'all', title: 'All' },
   { value: 'received', title: 'Received' },
   { value: 'sent', title: 'Sent' },
   { value: 'exchange', title: 'Exchange' },
]
const Wallet = ({ children }) => {
   const { tab } = useParams()
   const history = useHistory()
   const { pathname } = useLocation()
   const { isDarkTheme } = useSelector(state => state.theme)

   const currentTab = pathname.includes('/wallet/coins')
      ? 'Coins'
      : 'Collectibles'

   const [currentCoinTab, setCurrentCoinTab] = React.useState(COINS_TABS[0])
   const [historyFilter, setHistoryFilter] = React.useState(HISTORY_OPTIONS[0])

   React.useEffect(() => {
      if (pathname === '/wallet') {
         const lowerCasedTabs = TABS.map(el => el.toLowerCase())
         if (!tab || !lowerCasedTabs.length || !lowerCasedTabs.includes(tab)) {
            history.push(`/wallet/${lowerCasedTabs[0]}`)
         }
      }
   }, [history, tab, pathname])

   const renderContent = () => {
      if (pathname.includes('/artworks')) {
         return <Collectibles children={children} />
      }

      switch (tab) {
         case 'coins':
            return (
               <Coins
                  currentTab={currentCoinTab}
                  historyFilter={historyFilter}
               />
            )
         case 'collectibles':
            return <Collectibles children={children} />
         default:
            return null
      }
   }

   if (isDesktop()) {
      return (
         <DashboardLayout>
            <div className="DesktopWallet">
               <div className="DesktopWallet__header">
                  <Tabs
                     options={TABS}
                     current={currentTab}
                     onTabChange={newTab =>
                        history.push(`/wallet/${newTab.toLowerCase()}`)
                     }
                     isDarkTheme={isDarkTheme}
                  />
                  {currentTab === 'Coins' && (
                     <div className="DesktopWallet__header-coins">
                        <Select
                           options={HISTORY_OPTIONS}
                           onChange={option => setHistoryFilter(option)}
                           value={historyFilter}
                           isDarkTheme={isDarkTheme}
                        />
                        <Tabs
                           options={COINS_TABS}
                           current={currentCoinTab}
                           onTabChange={newTab => setCurrentCoinTab(newTab)}
                           isDarkTheme={isDarkTheme}
                        />
                     </div>
                  )}
               </div>
               {renderContent()}
            </div>
         </DashboardLayout>
      )
   }

   return (
      <DashboardLayout className="Wallet">
         <header className="Wallet__header">
            <Tabs
               options={TABS}
               current={capitalize(tab)}
               onTabChange={newTab =>
                  history.push(`/wallet/${newTab.toLowerCase()}`)
               }
               isDarkTheme={isDarkTheme}
            />
            <div className="Wallet__header-actions">
               {/* <ThemeIcon
                  className="Wallet__header-actions-icon"
                  name="upload"
                  size={20}
               />
               <ThemeIcon
                  className="Wallet__header-actions-icon"
                  name="download"
                  size={20}
               /> */}
               <ThemeIcon
                  className="Wallet__header-actions-icon"
                  name="bookmark"
                  size={20}
               />
            </div>
         </header>
         {renderContent()}
      </DashboardLayout>
   )
}

export default Wallet
